var _excluded = ["className", "classes", "disabled", "status", "hideLabel", "hint", "id", "iframeField", "name", "children", "required", "messages"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import FieldLabel from '../internal/field/field-label';
import FieldHint from '../internal/field/field-hint';
import FieldInput from '../internal/field/field-input';
require("./field.css");
var styles = {
  "iframeField": "iframeField-2h2gl"
};
var Field = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      className,
      classes,
      disabled,
      status,
      hideLabel,
      hint,
      id,
      iframeField,
      name,
      children,
      required,
      messages
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var labelId = "".concat(id, "-label");
  var hintId = "".concat(id, "-hint");
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(FieldLabel, {
    className: cs(classes === null || classes === void 0 ? void 0 : classes.label, {
      'lll-hidden-visually': hideLabel
    }),
    htmlFor: id,
    id: labelId,
    required: required,
    optionalMessage: messages === null || messages === void 0 ? void 0 : messages.optional
  }, children), /*#__PURE__*/React.createElement(FieldInput, _extends({
    "aria-labelledby": labelId,
    id: id,
    name: name,
    disabled: iframeField ? null : disabled,
    "aria-disabled": disabled,
    "aria-describedby": hint ? hintId : null,
    required: iframeField ? null : required,
    status: status,
    ref: ref,
    tag: iframeField ? 'div' : undefined,
    className: cs(classes === null || classes === void 0 ? void 0 : classes.input, {
      [styles.iframeField]: iframeField
    }),
    passwordToggleMessage: messages === null || messages === void 0 ? void 0 : messages.passwordToggle
  }, otherProps)), /*#__PURE__*/React.createElement(FieldHint, {
    className: classes === null || classes === void 0 ? void 0 : classes.hint,
    id: hintId,
    status: status
  }, hint));
});
Field.propTypes = {
  /** When input type is 'password', render toggle button to show/hide password. */
  allowShowPassword: PropTypes.bool,
  /** The field's label */
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({
    label: PropTypes.string,
    input: PropTypes.string,
    hint: PropTypes.string
  }),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  /** Toggle to visually hide label text.
   * Text remains visible to assistive technologies. */
  hideLabel: PropTypes.bool,
  /** DO NOT USE - NOT ACCESSIBLE. When a status is set, hide the icon. */
  hideStatusIcon: PropTypes.bool,
  /** Hint text for status messages. */
  hint: PropTypes.node,
  id: PropTypes.string.isRequired,
  /**
   * Flag to render an empty div capable of containing an iframe
   * for third party payment integrations.
   */
  iframeField: PropTypes.bool,
  /** Localized strings */
  messages: PropTypes.shape({
    /** Label for optional message next to field label: "Optional" */
    optional: PropTypes.string,
    /** Label for show/hide password toggle: "Show password" */
    passwordToggle: PropTypes.string
  }),
  name: PropTypes.string,
  required: PropTypes.bool,
  status: PropTypes.oneOf(['success', 'warning', 'error'])
};
Field.defaultProps = {
  allowShowPassword: false,
  classes: null,
  className: null,
  disabled: false,
  hideLabel: false,
  hideStatusIcon: false,
  hint: null,
  iframeField: false,
  messages: {},
  name: null,
  required: true,
  status: null
};
export default Field;